import store from '@/store';
import MovieServices from "@/apiServices/MovieServices";

function initialState() {
    return {
        allMovies: []
    }
}

const state = initialState();

const mutations = {
    ON_SET_MASTER_STORE_MOVIES: (state, payload) => {
        state.allMovies = payload
    }
}

const actions = {
    onGetMovieItemList: async ({ dispatch, commit, state }, payload = {}) => {
        await commit('ON_SET_MASTER_STORE_MOVIES', [])
        MovieServices.GetAllMovies(payload)
            .then(async (response) => {
                const { data: { data } } = response
                if (response['data'] && response.data.status) {
                    await commit('ON_SET_MASTER_STORE_MOVIES', data)
                } else {
                    store.dispatch("AppSetting/showAdminErrorMessage", { message: data.message });
                }
            }).catch((error) => {
                console.log('Catch Error on onGetAllDomainsItemList', error);
            }).finally(async () => {
            });

    }
}

const getters = {
    getAllMoviesListItems: state => state.allMovies
}

export default {
    state,
    mutations,
    actions,
    getters
}